import { Field, Formik } from '@components/Form'
import Header from '@components/Header'
import Calendar from '@components/HistoricCalendar'
import HistoricList from '@components/HistoricList'
import ValuationResult from '@components/ValuationResult'
import ValuationService from '@services/valuation'
import { debounce } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { groupValuationsCallback, searchedValuations } from './historic.helpers'
import {
  Body,
  CalendarContainer,
  FiltersContainer,
  IconWrapper,
  List,
  ListContainer,
  Main,
} from './styles'
import { SearchIcon } from '@icons'

const Historic = () => {
  const [valuations, setValuations] = useState([])
  const [selectedValuation, setSelectedValuation] = useState(null)
  const [selectedValuationId, setSelectedValuationId] = useState(null)
  const [filteredValuations, setFilteredValuations] = useState([])
  const [loading, setLoading] = useState(true)
  const [sortBy] = useState('createdAt')
  const [selectedMonth, setSelectedMonth] = useState(null)

  const groupValuations = useCallback(groupValuationsCallback, [sortBy])

  const searchValuations = value => {
    if (value) {
      setFilteredValuations(
        groupValuations(
          searchedValuations(searchedValuations(value, valuations)),
        ),
      )
    } else {
      setFilteredValuations(groupValuations(valuations))
    }
  }

  const debouncedSearch = debounce(searchValuations, 150)

  useEffect(() => {
    const loadValuationResult = async () => {
      const valuationService = new ValuationService()
      setSelectedValuation(
        await valuationService.getValuationById(selectedValuationId),
      )
    }
    selectedValuationId &&
      selectedValuation?.id !== selectedValuationId &&
      loadValuationResult()
  }, [selectedValuation, selectedValuationId])

  useEffect(() => {
    const fetchValuations = async () => {
      const valuationService = new ValuationService()
      const valuationResponse = await valuationService.getValuations('format')
      const groupedValuations = groupValuations(valuationResponse)
      setValuations(groupedValuations)
      setSelectedMonth(groupedValuations[groupedValuations.length - 1])
      setFilteredValuations(groupedValuations)
      setLoading(false)
    }
    fetchValuations()
  }, [groupValuations])

  return (
    <Main>
      <Header />
      <Body>
        <CalendarContainer>
          {!loading && (
            <Calendar
              active={selectedMonth}
              onMonthClick={setSelectedMonth}
              valuations={valuations}
            />
          )}
        </CalendarContainer>
        <ListContainer>
          <FiltersContainer>
            <Formik initialValues={{ search: '' }} onSubmit={() => null}>
              {({ values, handleChange, setFieldValue }) => (
                <React.Fragment>
                  <IconWrapper>
                    <SearchIcon />
                  </IconWrapper>
                  <Field
                    historic
                    placeholder="Filtre as Avaliações"
                    name="search"
                    value={values.search}
                    onChange={e => {
                      debouncedSearch(e.target.value)
                      handleChange(e)
                    }}
                  />
                </React.Fragment>
              )}
            </Formik>
          </FiltersContainer>
          {filteredValuations.length > 0 && (
            <List>
              <HistoricList
                setSelectedValuationId={setSelectedValuationId}
                selectedMonth={selectedMonth}
                valuations={filteredValuations}
              />
            </List>
          )}
        </ListContainer>
      </Body>
      {selectedValuation && selectedValuationId && (
        <ValuationResult
          valuation={selectedValuation}
          realties={selectedValuation.ad_sample}
          goBack={() => {
            setSelectedValuationId(null)
          }}
        />
      )}
    </Main>
  )
}

export default Historic
